import React from "react"
import type { IconButtonProps } from "@chakra-ui/react"
import { IconButton } from "@chakra-ui/react"

interface Props extends IconButtonProps {
  onClick: () => void
  icon: React.ReactElement
}

export const BasketIconButton: React.FC<Props> = (props) => {
  const { isDisabled } = props
  return (
    <IconButton
      borderRadius="0"
      width="1.5rem"
      height="1.5rem"
      marginTop="0.25rem"
      border="0"
      _hover={{
        background: "transparent !important",
        cursor: isDisabled ? "cursor" : "pointer",
      }}
      _focus={{
        boxShadow: "0",
        background: "transparent !important",
      }}
      background="transparent"
      minW="0"
      {...props}
    />
  )
}
